import React from 'react'
import {PaymentCheckoutTransaction} from '../containers'

export default function PaymentCheckoutTransactionScreen() {
  return <PaymentCheckoutTransaction />
}
